import { gql } from "@apollo/client";

export const GET_ADDRESS_PERSON_HISTORY = gql`
  query GET_ADDRESS($addressId: ID!, $originatorId: ID!) {
    getAddress(addressId: $addressId, originatorId: $originatorId) {
      id
      associatedPeople {
        history {
          aliases {
            id
            target {
              id
              validPersonAlerts {
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          personalAttribute {
            lastName
            firstName
            middleName
            homeAddress {
              name
            }
            dob
            phone
          }
          validPersonAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
          }
        }
      }
    }
  }
`;
